import { render } from "./file-upload-modal.vue?vue&type=template&id=21e897cd"
import script from "./file-upload-modal.vue?vue&type=script&lang=js"
export * from "./file-upload-modal.vue?vue&type=script&lang=js"

import "./file-upload-modal.vue?vue&type=style&index=0&id=21e897cd&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__